export default "<p>general-form works!</p>\n"